<div *ngIf="!isIcon" class="avatar" [style]="style" [innerHtml]="hasPhoto ? '' : letter"></div>
<svg *ngIf="isIcon && photo" class="avatar" [icon]="photo" [style]="style"></svg>
